module.exports = __webpack_public_path__ + "img/dish-2.4fb8fc6f.png";